import { Flex, Text } from "@chakra-ui/react"
import { useReservationsContext } from "providers/ReservationsProvider/ReservationsProvider"

import { useUI } from "providers/UIProvider"

const ReservationDetailsPrices: React.FC = () => {
  const { T } = useUI()
  const { currentReservation: reservation } = useReservationsContext()

  return (
    <Flex
      padding="16px 23px"
      justifyContent="space-between"
      borderBottom="1px solid #E9F2FD"
      width="100%"
      alignItems="center"
      height="50px"
    >
      <Text fontSize="12px">{T("booking.details.modal.booking.service_price")}</Text>
      <Flex
        alignItems="center"
        justifyContent="center"
        fontSize="18px"
        color="#046CEC"
        height="32px"
        width="68px"
        border="1px solid #046CEC"
        borderRadius="16px"
        fontWeight="500"
      >
        {reservation?.price}₾
      </Flex>
    </Flex>
  )
}

export default ReservationDetailsPrices